import React from 'react'

import { StyledRouterNavLink } from './styles'
import Button from 'components/Button'

import { useNavbar } from 'context/navbar-context'

const NavLink = ({ children, ...props }) => {
  const { isNavbarOpenOnMobile, setIsNavbarOpenOnMobile } = useNavbar()

  return (
    <StyledRouterNavLink {...props}>
      <Button
        onClick={() => setIsNavbarOpenOnMobile(!isNavbarOpenOnMobile)}
        textAlign='left'
        size='smallest'
        variant='ghost'
      >
        {children}
      </Button>
    </StyledRouterNavLink>
  )
}

export default NavLink
